import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FaIconDefinition } from '../../models';
import { PanelHostService } from '../../services/panel-host.service';
import { PanelStore, PanelType } from '../../services/panel-store';

@Component({
  selector: 'app-slide-out-panel',
  imports: [FaIconComponent],
  templateUrl: './slide-out-panel.component.html',
  styleUrls: ['./slide-out-panel.component.css'],
  host: {
    '[class.slide-out-left]': 'direction() === "left"',
    '[class.slide-out-right]': 'direction() === "right"',
    '[class.open]': 'isOpen()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlideOutPanelComponent  implements OnInit {

  panelName = input.required<PanelType>()
  headerTitle = input<string>('')
  headerIcon = input<FaIconDefinition>(['far', 'comments'])
  direction = input<"right" | "left">("left")


  panelStore = inject(PanelStore)
  panelHost = inject(PanelHostService)
  isOpen = signal(false)
  constructor() { }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.isOpen()) {
      void this.close();
    }
  }

  ngOnInit() {

    this.panelStore.activeSlideOut$.subscribe(panel => {
      this.isOpen.set(panel === this.panelName());
    });

  }

  close(): void {
    void this.panelHost.dismiss();
  }

}
